var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardDoubleArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8765 111.313C44.314 113.75 48.2515 113.75 50.689 111.313L75.0015 87.1252L99.2515 111.375C101.689 113.813 105.626 113.813 108.064 111.375C110.501 108.938 110.501 105 108.064 102.563L79.3765 73.8752C76.939 71.4377 73.0015 71.4377 70.564 73.8752L41.8765 102.5C39.439 104.938 39.439 108.875 41.8765 111.313Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8765 70.1248C44.314 72.5623 48.2515 72.5623 50.689 70.1248L75.0015 45.9373L99.2515 70.1873C101.689 72.6248 105.626 72.6248 108.064 70.1873C110.501 67.7498 110.501 63.8123 108.064 61.3748L79.3765 32.6873C76.939 30.2498 73.0015 30.2498 70.564 32.6873L41.8765 61.3123C39.439 63.7498 39.439 67.6873 41.8765 70.1248Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardDoubleArrowUp);
export default __webpack_public_path__ + "static/media/keyboard_double_arrow_up.15fa9082.svg";
export { ForwardRef as ReactComponent };